(function () {
  const FREE_GIFT_API_URL = `${window.apiUrl}/callback/web-settings`;

  // Cache
  const GIFT_SETTINGS_CACHE_KEY = "gift_settings_cache_v1";
  const GIFT_SETTINGS_CACHE_TIME_KEY = "gift_settings_cache_time_v1";
  const GIFT_SETTINGS_CACHE_TTL_MS = 6 * 60 * 60 * 1000;

  // Reliability + speed (tuned)
  const FLOW_DEBOUNCE_MS = 10;            // faster start
  const RETRY_IF_NO_DRAWER_MS = 120;
  const SELF_CART_UNLOCK_MS = 250;
  const FLOW_FAILSAFE_MS = 7000;

  // Cart freshness (less /cart.js calls)
  const CART_FRESH_FETCH_TTL_MS = 1200;   // reuse last snapshot for 1.2s
  const POST_ADD_CART_REFRESH_MS = 220;   // after /cart/add.js, refresh snapshot once

  // Shimmer
  const SHIMMER_ID = "kushals-cart-s-skeleton";
  const SHIMMER_FADE_OUT_MS = 220;

  function isEligibleNewUser() {
    return window.FREE_GIFT_NEW_USER_ONLY === true;
  }

  // ✅ required by your cart drawer guard (ct-cart-ajax)
  // window.__FREE_GIFT_SELF_CHANGE = true while we mutate cart, so drawer won't call runFreeGiftFlow again.
  if (typeof window.__FREE_GIFT_SELF_CHANGE === "undefined") window.__FREE_GIFT_SELF_CHANGE = false;
  if (typeof window.__FREE_GIFT_SILENT_RENDER === "undefined") window.__FREE_GIFT_SILENT_RENDER = false;

  let _isSelfChangingCart = false;
  let _flowQueued = false;
  let _uiQueued = false;
  let _isDecorating = false;

  let _flowRunning = false;
  let _flowRunAgain = false;
  let _flowFailsafe = null;

  let __LAST_CART_SNAPSHOT = null;
  let __LAST_SETTINGS_SNAPSHOT = null;

  // cart freshness throttle
  let __LAST_CART_FETCH_AT = 0;
  let __CART_FETCH_INFLIGHT = null;

  // ✅ prevent duplicate add/remove races
  let __MUTATION_INFLIGHT = null; // Promise lock
  let __LAST_MUTATION_AT = 0;
  let __LAST_TARGET_VARIANT = null;

  const _giftVariantPriceCache = new Map();

  /* -------------------------
     Shimmer
     ------------------------- */
  function _getShimmerEl() { return document.getElementById(SHIMMER_ID); }

  function shimmerShow() {
    const el = _getShimmerEl();
    if (!el) return;
    el.style.display = "";
    el.hidden = false;
    el.classList.remove("kushals-cart-s-fadeout");
    el.setAttribute("aria-hidden", "false");
  }

  function shimmerHideSmooth() {
    const el = _getShimmerEl();
    if (!el) return;
    el.classList.add("kushals-cart-s-fadeout");
    setTimeout(() => {
      el.hidden = true;
      el.setAttribute("aria-hidden", "true");
      el.style.display = "none";
      el.classList.remove("kushals-cart-s-fadeout");
    }, SHIMMER_FADE_OUT_MS);
  }

  function giftExistsInDom() {
    return !!document.querySelector('li.mm-ajaxcart-item.ajaxcartItem[data-free-gift="true"]');
  }

  /* -------------------------
     Queue
     ------------------------- */
  function queueRunFlow(reason) {
    if (_flowQueued) return;
    _flowQueued = true;
    setTimeout(() => {
      _flowQueued = false;
      runFreeGiftFlow(reason);
    }, FLOW_DEBOUNCE_MS);
  }

  function queueUIUpdate() {
    if (_uiQueued) return;
    _uiQueued = true;
    requestAnimationFrame(() => {
      _uiQueued = false;
      decorateGiftItemsUI();
      moveGiftToTop();
    });
  }

  /* -------------------------
     Settings tiers
     ------------------------- */
  function normalizeTiersFromSettings(settingsJson) {
    const dtos = settingsJson?.cartGiftingDTOS;
    if (!Array.isArray(dtos) || dtos.length === 0) return [];

    return dtos
      .map((dto) => {
        const variantId = Number(dto.variantId);
        const minRupees = Number(dto.priceRangeMin);
        const maxRupees = Number(dto.priceRangeMax);
        if (!Number.isFinite(variantId) || !Number.isFinite(minRupees) || !Number.isFinite(maxRupees)) return null;

        return {
          variantId,
          minRupees,
          maxRupees,
          minPaise: minRupees * 100,
          maxPaise: maxRupees * 100,
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.minPaise - b.minPaise);
  }

  function pickTier(subtotalPaise, tiers) {
    for (const t of tiers) {
      if (subtotalPaise >= t.minPaise && subtotalPaise <= t.maxPaise) return t;
    }
    return null;
  }

  /* -------------------------
     Variant price cache
     ------------------------- */
  function _formatRupeesFromPaise(paise) {
    const rupees = Math.ceil(Number(paise) / 100);
    return `₹${rupees.toLocaleString("en-IN")}`;
  }

  async function _fetchVariantOriginalPricePaise(variantId) {
    if (!variantId) return null;
    if (_giftVariantPriceCache.has(variantId)) return _giftVariantPriceCache.get(variantId);

    const key = `gift_variant_price_${variantId}`;
    const cached = sessionStorage.getItem(key);
    if (cached) {
      const val = Number(cached);
      if (Number.isFinite(val)) {
        _giftVariantPriceCache.set(variantId, val);
        return val;
      }
    }

    try {
      const res = await fetch(`/variants/${variantId}.js`, { method: "GET", headers: { Accept: "application/json" } });
      if (!res.ok) return null;
      const json = await res.json();
      const pricePaise = Number(json.price);
      if (!Number.isFinite(pricePaise)) return null;

      _giftVariantPriceCache.set(variantId, pricePaise);
      sessionStorage.setItem(key, String(pricePaise));
      return pricePaise;
    } catch (_) {
      return null;
    }
  }
  

   function _disableGiftTitleLink(itemEl) {
  // your title block is: .mm-ajaxcart-item-name a
  const a = itemEl.querySelector(".mm-ajaxcart-item-name a");
  if (!a) return;

  // prevent double-binding on re-render
  if (a.getAttribute("data-freegift-link-disabled") === "1") return;
  a.setAttribute("data-freegift-link-disabled", "1");

  // Option A (recommended): keep text but make it non-clickable
  a.style.pointerEvents = "none";
  a.style.cursor = "default";
  a.removeAttribute("href"); // optional but nice (no long-press/open)
  a.setAttribute("aria-disabled", "true");

  // Extra safety: if some scripts still trigger click
  a.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      e.stopPropagation();
    },
    true // capture
  );
}
  /* -------------------------
     UI decorate
     ------------------------- */
  function _getVariantIdFromDataKey(dataKey) {
    if (!dataKey) return null;
    const v = Number(String(dataKey).split(":")[0]);
    return Number.isFinite(v) ? v : null;
  }

  function _findCartItemContainer(el) {
    if (!el) return null;
    return el.closest(".mm-ajaxcart-item, .mm-ajaxcart-item-main, .mm-ajaxcart-item-wrap") || null;
  }

  function _hideGiftControls(itemEl) {
    itemEl
      .querySelectorAll(".cart_remove_btn, .mm-ajaxcart-remove-item, .mm-ajaxcart-item-remove, .mm-ajaxcart-remove")
      .forEach((n) => (n.style.display = "none"));

    itemEl
      .querySelectorAll(
        ".mm-ajaxcart-item-quantity-main, .mm-ajaxcart-item-quantity, .quantity-plus, .quantity_svg_white, input.quantity-input, input.qty"
      )
      .forEach((n) => (n.style.display = "none"));
  }

async function _setGiftPriceDisplay(itemEl, variantId) {
  const priceEl =
    itemEl.querySelector(".mm-ajaxcart-item-price") ||
    itemEl.querySelector(".mm-ajaxcart-price") ||
    itemEl.querySelector(".cart__price") ||
    itemEl.querySelector(".price") ||
    itemEl.querySelector("[data-item-price]");
  if (!priceEl) return;

  priceEl.setAttribute("data-free-gift-price", "1");

  // ✅ Remove old price + strike svg, show only Free
  priceEl.style.textDecoration = "none";
  priceEl.innerHTML = `<span class="free-gift-new-price">Free Jewellery Box Added</span>`;
}


  async function decorateGiftItemsUI() {
    if (_isDecorating) return;
    _isDecorating = true;

    try {
      const drawer = document.querySelector(".mm-ajaxcart");
      if (!drawer) return;

      const settings = await callFreeGiftAPI();
      if (!settings) return;

      const tiers = normalizeTiersFromSettings(settings);
      if (!tiers.length) return;

      const giftVariantSet = new Set(tiers.map((t) => Number(t.variantId)));

      // Primary detection path: quantity inputs
      const qtyInputs = drawer.querySelectorAll("input.quantity-input[data-key], input.qty[data-key]");
      for (const input of qtyInputs) {
        const variantId = _getVariantIdFromDataKey(input.getAttribute("data-key"));
        if (!variantId || !giftVariantSet.has(variantId)) continue;

        const itemEl = _findCartItemContainer(input);
        if (!itemEl) continue;

        itemEl.setAttribute("data-free-gift", "true");
        _disableGiftTitleLink(itemEl);
        _hideGiftControls(itemEl);
        await _setGiftPriceDisplay(itemEl, variantId);
      }

      // Fallback detection path: variant attribute on cart row
      // Needed when quantity inputs are not rendered by Liquid conditions.
      const cartRows = drawer.querySelectorAll(".mm-ajaxcart-item[data-variant_id], .ajaxcartItem[data-variant_id]");
      for (const row of cartRows) {
        const variantId = Number(row.getAttribute("data-variant_id"));
        if (!Number.isFinite(variantId) || !giftVariantSet.has(variantId)) continue;

        row.setAttribute("data-free-gift", "true");
        _disableGiftTitleLink(row);
        _hideGiftControls(row);
        await _setGiftPriceDisplay(row, variantId);
      }
    } finally {
      _isDecorating = false;
    }
  }

  /* -------------------------
     Cart + settings fetch
     ------------------------- */
  async function fetchShopifyCartFresh() {
    const now = Date.now();
    if (__CART_FETCH_INFLIGHT) return __CART_FETCH_INFLIGHT;

    if (__LAST_CART_SNAPSHOT && now - __LAST_CART_FETCH_AT < CART_FRESH_FETCH_TTL_MS) {
      return __LAST_CART_SNAPSHOT;
    }

    __CART_FETCH_INFLIGHT = (async () => {
      try {
        const res = await fetch("/cart.js", { method: "GET", headers: { "Content-Type": "application/json" } });
        if (!res.ok) throw new Error("Failed to load cart");
        const cart = await res.json();
        __LAST_CART_SNAPSHOT = cart;
        __LAST_CART_FETCH_AT = Date.now();
        return cart;
      } finally {
        __CART_FETCH_INFLIGHT = null;
      }
    })();

    return __CART_FETCH_INFLIGHT;
  }

  async function callFreeGiftAPI() {
    if (__LAST_SETTINGS_SNAPSHOT) return __LAST_SETTINGS_SNAPSHOT;

    const cached = localStorage.getItem(GIFT_SETTINGS_CACHE_KEY);
    const cachedTime = localStorage.getItem(GIFT_SETTINGS_CACHE_TIME_KEY);

    if (cached && cachedTime) {
      const age = Date.now() - Number(cachedTime);
      if (age < GIFT_SETTINGS_CACHE_TTL_MS) {
        try {
          __LAST_SETTINGS_SNAPSHOT = JSON.parse(cached);
          return __LAST_SETTINGS_SNAPSHOT;
        } catch (_) { }
      }
    }

    try {
      const res = await fetch(FREE_GIFT_API_URL, { method: "GET", mode: "cors", headers: { Accept: "application/json" } });
      if (!res.ok) return null;

      const data = await res.json();
      localStorage.setItem(GIFT_SETTINGS_CACHE_KEY, JSON.stringify(data));
      window.KushalsStorageTTL && window.KushalsStorageTTL.touch(GIFT_SETTINGS_CACHE_KEY);
      localStorage.setItem(GIFT_SETTINGS_CACHE_TIME_KEY, String(Date.now()));
      window.KushalsStorageTTL && window.KushalsStorageTTL.touch(GIFT_SETTINGS_CACHE_TIME_KEY);
      __LAST_SETTINGS_SNAPSHOT = data;
      return data;
    } catch (_) {
      if (cached) {
        try {
          __LAST_SETTINGS_SNAPSHOT = JSON.parse(cached);
          return __LAST_SETTINGS_SNAPSHOT;
        } catch (_) { }
      }
      return null;
    }
  }

  function refreshCartUIFast() {
    const drawer = document.querySelector(".mm-ajaxcart");
    if (drawer && window.mmajaxcart && typeof window.mmajaxcart.AjaxcartRender === "function") {
      // If you want to skip loader during free-gift changes, set this flag and handle it in showLoader()
      window.__FREE_GIFT_SILENT_RENDER = true;
      window.mmajaxcart.AjaxcartRender();
      setTimeout(() => { window.__FREE_GIFT_SILENT_RENDER = false; }, 350);

      queueUIUpdate();
      setTimeout(queueUIUpdate, 120);
      return;
    }
  }

  /* -------------------------
     Move gift top
     ------------------------- */
  function moveGiftToTop() {
    const drawer = document.querySelector(".mm-ajaxcart");
    if (!drawer) return;

    const itemsWrapper =
      drawer.querySelector(".mm-ajaxcart-items") ||
      drawer.querySelector(".mm-ajaxcart-item-list") ||
      drawer.querySelector(".mm-ajaxcart-body") ||
      drawer.querySelector(".mm-ajaxcart-content") ||
      drawer;

    if (!itemsWrapper) return;

    const giftItems = itemsWrapper.querySelectorAll('[data-free-gift="true"]');
    if (!giftItems || !giftItems.length) return;

    giftItems.forEach((giftEl) => {
      if (itemsWrapper.firstElementChild !== giftEl) {
        itemsWrapper.insertBefore(giftEl, itemsWrapper.firstElementChild);
      }
    });
  }

  /* -------------------------
     Compute gift state (prevents duplicate)
     ------------------------- */
  function computeGiftState(cart, settings) {
    const tiers = normalizeTiersFromSettings(settings);
    const giftVariantSet = new Set(tiers.map((t) => Number(t.variantId)));

    let subtotal = 0;
    const giftLines = [];

    (cart.items || []).forEach((item) => {
      const isGift =
        (item.properties && item.properties._free_gift === "true") ||
        giftVariantSet.has(Number(item.variant_id));

      if (isGift) {
        giftLines.push(item);
      } else {
        subtotal += Number(item.price) * Number(item.quantity);
      }
    });

    const tier = pickTier(subtotal, tiers);
    const targetGiftVariantId = tier ? tier.variantId : null;

    return {
      tiers,
      tier,
      subtotal,
      targetGiftVariantId,
      giftVariantSet,
      giftLines,
      giftCount: giftLines.length,
      hasGift: giftLines.length > 0,
      // IMPORTANT: there can be multiple gifts; keep first as "current"
      currentGiftVariantId: giftLines.length ? Number(giftLines[0].variant_id) : null,
    };
  }

  /* -------------------------
     Cart mutations (LOCKED + fast)
     ------------------------- */
    const GIFT_REMOVE_COOLDOWN_MS = 1500;
    const _lastGiftRemoveByKey = new Map();

    async function removeAllGifts(state) {
      if (!state.giftLines.length) return;

      const now = Date.now();
      for (const g of state.giftLines) {
        const lastAt = _lastGiftRemoveByKey.get(g.key) || 0;
        if (now - lastAt < GIFT_REMOVE_COOLDOWN_MS) continue;

        _lastGiftRemoveByKey.set(g.key, now);
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: g.key, quantity: 0 }),
        });
      }
    }

  async function addGiftVariant(variantId) {
    // double-add guard (same target within 1s)
    if (variantId && __LAST_TARGET_VARIANT === variantId && (Date.now() - __LAST_MUTATION_AT) < 1000) {
      return false;
    }

    const addRes = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _free_gift: "true" },
      }),
    });

    __LAST_TARGET_VARIANT = variantId;
    __LAST_MUTATION_AT = Date.now();

    if (!addRes.ok) return false;

    // /cart/add.js does NOT return full cart -> refresh snapshot once (quick)
    setTimeout(() => {
      __LAST_CART_FETCH_AT = 0;
      fetchShopifyCartFresh().catch(() => { });
    }, POST_ADD_CART_REFRESH_MS);

    return true;
  }

  // ✅ serialize all cart mutations so we never double-add
  async function withMutationLock(fn) {
    if (__MUTATION_INFLIGHT) {
      try { await __MUTATION_INFLIGHT; } catch (_) { }
    }

    __MUTATION_INFLIGHT = (async () => {
      window.__FREE_GIFT_SELF_CHANGE = true; // stops ct-cart-ajax from calling flow again
      try {
        return await fn();
      } finally {
        setTimeout(() => { window.__FREE_GIFT_SELF_CHANGE = false; }, SELF_CART_UNLOCK_MS);
        __MUTATION_INFLIGHT = null;
      }
    })();

    return __MUTATION_INFLIGHT;
  }

    async function applyFreeGiftDecision(settings, cart) {
    const state = computeGiftState(cart, settings);

    // ✅ show shimmer immediately when tier reached (perceived speed)
    if (isEligibleNewUser() && state.targetGiftVariantId && !state.hasGift) shimmerShow();
    if (!isEligibleNewUser() || state.hasGift || !state.targetGiftVariantId) shimmerHideSmooth();

    // NOT eligible => remove
    if (!isEligibleNewUser()) {
      if (state.giftCount) {
        await withMutationLock(async () => {
           __LAST_CART_FETCH_AT = 0;  
          const fresh = await fetchShopifyCartFresh();
          const st2 = computeGiftState(fresh, settings);
          if (st2.giftCount) await removeAllGifts(st2);
        });
        return true;
      }
      return false;
    }

    // No tier => remove
    if (!state.targetGiftVariantId) {
      if (state.giftCount) {
        await withMutationLock(async () => {
           __LAST_CART_FETCH_AT = 0;  
          const fresh = await fetchShopifyCartFresh();
          const st2 = computeGiftState(fresh, settings);
          if (st2.giftCount) await removeAllGifts(st2);
        });
        return true;
      }
      return false;
    }

    // If multiple gifts OR wrong gift OR missing gift -> normalize to exactly 1 correct gift
    const needsFix =
      (state.giftCount > 1) ||
      (state.hasGift && Number(state.currentGiftVariantId) !== Number(state.targetGiftVariantId)) ||
      (!state.hasGift);

    if (!needsFix) return false;

    await withMutationLock(async () => {
      // re-check with fresh cart inside lock (prevents race duplicates)
      const fresh = await fetchShopifyCartFresh();
      const st2 = computeGiftState(fresh, settings);

      // if already correct (someone else fixed), do nothing
      if (st2.giftCount === 1 && Number(st2.currentGiftVariantId) === Number(st2.targetGiftVariantId)) return;

      // remove all existing gifts
      if (st2.giftCount) await removeAllGifts(st2);

      // add correct gift (only if tier still valid)
      const fresh2 = await fetchShopifyCartFresh();
      const st3 = computeGiftState(fresh2, settings);
      if (st3.targetGiftVariantId) {
        // if gift already exists now, don't add again
        const alreadyHasTarget = (fresh2.items || []).some((it) => Number(it.variant_id) === Number(st3.targetGiftVariantId) &&
          ((it.properties && it.properties._free_gift === "true") || st3.giftVariantSet.has(Number(it.variant_id)))
        );
        if (!alreadyHasTarget) {
          await addGiftVariant(st3.targetGiftVariantId);
        }
      }
    });

    return true;
  }

  /* -------------------------
     Main flow
     ------------------------- */

  async function runFreeGiftFlow(reason) {
    if (_flowRunning) {
      _flowRunAgain = true;
      return;
    }

    _flowRunning = true;
    clearTimeout(_flowFailsafe);

    _flowFailsafe = setTimeout(() => {
      _flowRunning = false;
      _flowRunAgain = false;
    }, FLOW_FAILSAFE_MS);

    try {
      const drawer = document.querySelector(".mm-ajaxcart");
      if (!drawer) setTimeout(() => queueRunFlow("retryDrawer"), RETRY_IF_NO_DRAWER_MS);

      const settings = await callFreeGiftAPI();
      if (!settings) return;

      const cart = await fetchShopifyCartFresh();

      if (_isSelfChangingCart) return;

      _isSelfChangingCart = true;
      let didMutate = false;

      try {
        didMutate = await applyFreeGiftDecision(settings, cart);
      } finally {
        setTimeout(() => (_isSelfChangingCart = false), SELF_CART_UNLOCK_MS);
      }

    // After mutation, allow the cart UI to refresh; no extra flow needed

      if (didMutate) {
  refreshCartUIFast();      // heavy
  queueUIUpdate();
  setTimeout(queueUIUpdate, 120);
} else {
  queueUIUpdate();          // light only
}


      if (giftExistsInDom()) shimmerHideSmooth();
    } catch (_) {
    } finally {
      clearTimeout(_flowFailsafe);
      _flowFailsafe = null;

      _flowRunning = false;
      if (_flowRunAgain) {
        _flowRunAgain = false;
        queueRunFlow("rerun");
      }
    }
  }

  /* -------------------------
     Hooks
     ------------------------- */
  document.addEventListener("DOMContentLoaded", () => {
    queueRunFlow("init");
    setTimeout(() => queueRunFlow("init+150"), 150);
    // single delayed warmup is enough

   const drawer = document.querySelector(".mm-ajaxcart");
if (drawer) {
  let __UI_OBS_LAST = 0;

  const obs = new MutationObserver(() => {
    const now = Date.now();
    // allow UI update max once every 300ms
    if (now - __UI_OBS_LAST < 300) return;
    __UI_OBS_LAST = now;

    queueUIUpdate();
  });

  obs.observe(drawer, { childList: true, subtree: true });
}

  });

  /* -------------------------
     Expose trigger for ct-cart-ajax.js.liquid
     ------------------------- */
  window.runFreeGiftFlow = function (reason) {
    queueRunFlow(reason || "external");
  };

  /* -------------------------
     Fetch patch: rerun + keep snapshot (FAST)
     ------------------------- */
  if (!window.__FREE_GIFT_FETCH_PATCHED_V7_FAST) {
    window.__FREE_GIFT_FETCH_PATCHED_V7_FAST = true;

    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const input = args[0];
      const url = typeof input === "string" ? input : input?.url;

      const res = await originalFetch.apply(this, args);

      try {
        if (url && (url.includes("/cart/change.js") || url.includes("/cart/update.js"))) {
          // change/update usually return full cart -> store snapshot
          try {
            const json = await res.clone().json();
            if (json && json.items && typeof json.total_price !== "undefined") {
              __LAST_CART_SNAPSHOT = json;
              __LAST_CART_FETCH_AT = Date.now();
            }
          } catch (_) { }
        }

        if (url && (url.includes("/cart/add.js") || url.includes("/cart/change.js") || url.includes("/cart/update.js"))) {
          // invalidate freshness so next run can refetch if needed
          __LAST_CART_FETCH_AT = 0;

          // avoid extra runs for our own mutations
          if (!window.__FREE_GIFT_SELF_CHANGE) {
            queueRunFlow("cartEndpoint");
            queueUIUpdate();
            setTimeout(queueUIUpdate, 120);
          }
        }
      } catch (_) { }

      return res;
    };
  }
})();

/**
 * FREE-GIFT-TIER-LOADER.js  (Standalone, FAST + CLEAR LOGS)
 * ---------------------------------------------------------
 * ✅ Works for multiple tiers (ex: 3000 / 5000 / 10000) using your API cartGiftingDTOS
 * ✅ When cart subtotal (excluding gift) ENTERS a tier => IMMEDIATELY show loader
 *    - Keep loader ON until that tier's gift is actually ADDED (or SWAPPED) in cart
 *    - Then hide loader AFTER 1 second
 * ✅ When cart subtotal DROPS below a tier (no tier) => IMMEDIATELY show loader
 *    - Keep loader ON until gift is actually REMOVED
 *    - Then hide loader AFTER 1 second
 * ✅ Console logs like:
 *    "Showing loader for T1 | ADD gift 123456789"
 *    "Showing loader for T2 | SWAP gift 111 -> 222"
 *    "Showing loader for NO_TIER | REMOVE gift(s)"
 *    "Hiding loader for T1 | completed"
 *
 */

(function () {
  const FREE_GIFT_API_URL = `${window.apiUrl}/callback/web-settings`;

  // -------------------------
  // CONFIG
  // -------------------------
  const HIDE_DELAY_MS = 1000;       // hide loader 1 sec after completion
  const POLL_INTERVAL_MS = 160;     // check cart quickly
  const POLL_TIMEOUT_MS = 9000;     // stop waiting after 9s
  const DECISION_DEBOUNCE_MS = 25;  // quick debounce
  const CART_CACHE_TTL_MS = 250;    // reuse cart snapshot for 250ms

  // Cache settings (same keys as your script)
  const GIFT_SETTINGS_CACHE_KEY = "gift_settings_cache_v1";
  const GIFT_SETTINGS_CACHE_TIME_KEY = "gift_settings_cache_time_v1";
  const GIFT_SETTINGS_CACHE_TTL_MS = 6 * 60 * 60 * 1000;

  // -------------------------
  // UTIL
  // -------------------------

  function isEligibleNewUser() {
    return window.FREE_GIFT_NEW_USER_ONLY === true;
  }

  function safeShowLoader(reasonText) {
    if (typeof window.showLoader === "function") {
      showLoader();
    }
  }

  function fmtTierLabel(idx) {
    return idx > 0 ? `T${idx}` : "NO_TIER";
  }

  // -------------------------
  // SETTINGS
  // -------------------------
  let __SETTINGS = null;

  async function fetchSettings() {
    if (__SETTINGS) return __SETTINGS;

    // local cache first
    const cached = localStorage.getItem(GIFT_SETTINGS_CACHE_KEY);
    const cachedTime = localStorage.getItem(GIFT_SETTINGS_CACHE_TIME_KEY);
    if (cached && cachedTime) {
      const age = Date.now() - Number(cachedTime);
      if (age < GIFT_SETTINGS_CACHE_TTL_MS) {
        try {
          __SETTINGS = JSON.parse(cached);
          return __SETTINGS;
        } catch (_) {}
      }
    }

    // network
    try {
      const res = await fetch(FREE_GIFT_API_URL, { method: "GET", mode: "cors", headers: { Accept: "application/json" } });
      if (!res.ok) return null;
      const data = await res.json();
      localStorage.setItem(GIFT_SETTINGS_CACHE_KEY, JSON.stringify(data));
      window.KushalsStorageTTL && window.KushalsStorageTTL.touch(GIFT_SETTINGS_CACHE_KEY);
      localStorage.setItem(GIFT_SETTINGS_CACHE_TIME_KEY, String(Date.now()));
      window.KushalsStorageTTL && window.KushalsStorageTTL.touch(GIFT_SETTINGS_CACHE_TIME_KEY);
      __SETTINGS = data;
      return __SETTINGS;
    } catch (_) {
      // fallback to old cache if exists
      if (cached) {
        try {
          __SETTINGS = JSON.parse(cached);
          return __SETTINGS;
        } catch (_) {}
      }
      return null;
    }
  }

  function normalizeTiers(settingsJson) {
    const dtos = settingsJson?.cartGiftingDTOS;
    if (!Array.isArray(dtos) || dtos.length === 0) return [];

    // Using your min/max ranges (rupees) -> convert to paise
    const tiers = dtos
      .map((dto) => {
        const variantId = Number(dto.variantId);
        const minR = Number(dto.priceRangeMin);
        const maxR = Number(dto.priceRangeMax);
        if (!Number.isFinite(variantId) || !Number.isFinite(minR) || !Number.isFinite(maxR)) return null;
        return {
          variantId,
          minPaise: minR * 100,
          maxPaise: maxR * 100,
          minRupees: minR,
          maxRupees: maxR,
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.minPaise - b.minPaise);

    return tiers;
  }

  function pickTier(subtotalPaise, tiers) {
    for (let i = 0; i < tiers.length; i++) {
      const t = tiers[i];
      if (subtotalPaise >= t.minPaise && subtotalPaise <= t.maxPaise) {
        return { tier: t, tierIndex: i + 1 };
      }
    }
    return { tier: null, tierIndex: 0 };
  }

  // -------------------------
  // CART (fast cache)
  // -------------------------
  let __CART_SNAPSHOT = null;
  let __CART_AT = 0;
  let __CART_INFLIGHT = null;

  async function fetchCartFresh() {
    const now = Date.now();
    if (__CART_INFLIGHT) return __CART_INFLIGHT;

    if (__CART_SNAPSHOT && (now - __CART_AT) < CART_CACHE_TTL_MS) {
      return __CART_SNAPSHOT;
    }

    __CART_INFLIGHT = (async () => {
      try {
        const res = await fetch("/cart.js", { method: "GET", headers: { "Content-Type": "application/json" } });
        if (!res.ok) throw new Error("cart.js failed");
        const cart = await res.json();
        __CART_SNAPSHOT = cart;
        __CART_AT = Date.now();
        return cart;
      } finally {
        __CART_INFLIGHT = null;
      }
    })();

    return __CART_INFLIGHT;
  }

  function invalidateCart() {
    __CART_AT = 0;
  }

  // -------------------------
  // GIFT STATE (detect duplicates too)
  // -------------------------
  function computeGiftState(cart, tiers) {
    const giftVariantSet = new Set(tiers.map((t) => Number(t.variantId)));

    let subtotal = 0;
    const giftLines = [];

    (cart.items || []).forEach((item) => {
      const isGift =
        (item.properties && item.properties._free_gift === "true") ||
        giftVariantSet.has(Number(item.variant_id));

      if (isGift) {
        giftLines.push(item);
      } else {
        subtotal += Number(item.price) * Number(item.quantity);
      }
    });

    const picked = pickTier(subtotal, tiers);
    const targetGiftVariantId = picked.tier ? Number(picked.tier.variantId) : null;

    const uniqueGiftVariants = new Set(giftLines.map((g) => Number(g.variant_id)));

    return {
      subtotalPaise: subtotal,
      tierIndex: picked.tierIndex,               // 0 => no tier
      tier: picked.tier,
      targetGiftVariantId,
      giftLines,
      giftCount: giftLines.length,
      uniqueGiftCount: uniqueGiftVariants.size,
      currentGiftVariantId: giftLines.length ? Number(giftLines[0].variant_id) : null,
      hasTargetGift: targetGiftVariantId
        ? giftLines.some((g) => Number(g.variant_id) === Number(targetGiftVariantId))
        : false,
    };
  }

  // What action is required right now?
  // (Loader should show ONLY when action is required)
  function decideAction(state) {
    // not eligible => should have no gift
    if (!isEligibleNewUser()) {
      if (state.giftCount > 0) return { type: "REMOVE", label: "NOT_ELIGIBLE", tierIndex: 0 };
      return { type: "NONE", label: "NOT_ELIGIBLE_OK", tierIndex: 0 };
    }

    // no tier => should have no gift
    if (!state.targetGiftVariantId) {
      if (state.giftCount > 0) return { type: "REMOVE", label: "DROP_BELOW_TIER", tierIndex: 0 };
      return { type: "NONE", label: "NO_TIER_OK", tierIndex: 0 };
    }

    // tier exists
    if (state.giftCount === 0) {
      return { type: "ADD", label: "ENTER_TIER", tierIndex: state.tierIndex, target: state.targetGiftVariantId };
    }

    // duplicates (same gift added twice OR multiple gifts)
    if (state.giftCount > 1 || state.uniqueGiftCount > 1) {
      // normalize (remove extras + ensure correct)
      return { type: "CLEANUP", label: "DUPLICATE_GIFTS", tierIndex: state.tierIndex, target: state.targetGiftVariantId };
    }

    // wrong gift
    if (Number(state.currentGiftVariantId) !== Number(state.targetGiftVariantId)) {
      return {
        type: "SWAP",
        label: "TIER_CHANGED",
        tierIndex: state.tierIndex,
        from: state.currentGiftVariantId,
        target: state.targetGiftVariantId
      };
    }

    // correct
    return { type: "NONE", label: "TIER_OK", tierIndex: state.tierIndex };
  }

  // When is it "completed" (so we hide loader)?
  function isFinalState(state) {
    if (!isEligibleNewUser()) return state.giftCount === 0;
    if (!state.targetGiftVariantId) return state.giftCount === 0;
    // Must be exactly one gift and must be target
    return state.giftCount === 1 && Number(state.currentGiftVariantId) === Number(state.targetGiftVariantId);
  }

  // -------------------------
  // LOADER STATE MACHINE
  // -------------------------
  let __LOADER_ACTIVE = false;
  let __LOADER_HIDE_TIMER = null;
  let __POLL_TIMER = null;
  let __POLL_START = 0;
  let __ACTION_START_CART_AT = 0;
  let __ACTION_START_AT = 0;

  // Track last shown "action signature" so we don't spam show loader again
  let __LAST_ACTION_SIG = null;

  function clearPoll() {
    if (__POLL_TIMER) clearInterval(__POLL_TIMER);
    __POLL_TIMER = null;
    __POLL_START = 0;
  }

  function scheduleHide(reason) {
    if (__LOADER_HIDE_TIMER) clearTimeout(__LOADER_HIDE_TIMER);
    __LOADER_HIDE_TIMER = setTimeout(() => {
      __LOADER_HIDE_TIMER = null;
      __LOADER_ACTIVE = false;
      window.closeLoader();
      clearPoll();
    }, HIDE_DELAY_MS);
  }

  function showNow(reason) {
    if (__LOADER_HIDE_TIMER) { clearTimeout(__LOADER_HIDE_TIMER); __LOADER_HIDE_TIMER = null; }
    if (__LOADER_ACTIVE) return;
    __LOADER_ACTIVE = true;
    __ACTION_START_CART_AT = __CART_AT;
    __ACTION_START_AT = Date.now();
    invalidateCart(); // force fresh cart while waiting for mutation
    safeShowLoader(reason);
  }

  function startPollUntilFinal(tiers, reasonForLog) {
    if (__POLL_TIMER) return;
    __POLL_START = Date.now();

    __POLL_TIMER = setInterval(async () => {
      try {
        const cart = await fetchCartFresh();
        const state = computeGiftState(cart, tiers);
        const finalOk = isFinalState(state);

        if (finalOk) {
          // Only hide after we have observed a fresher cart since action start
          if (__CART_AT > __ACTION_START_CART_AT && (Date.now() - __ACTION_START_AT) > 100) {
            scheduleHide(reasonForLog);
            return;
          }
        }

        if (Date.now() - __POLL_START > POLL_TIMEOUT_MS) {
          warn("Polling timeout, hiding loader anyway", { reason: reasonForLog });
          scheduleHide("timeout");
          return;
        }
      } catch (_) {
        // ignore
      }
    }, POLL_INTERVAL_MS);
  }

  // -------------------------
  // MAIN CHECK (debounced)
  // -------------------------
  let __QUEUED = false;

  function queueCheck(reason) {
    if (__QUEUED) return;
    __QUEUED = true;
    setTimeout(() => {
      __QUEUED = false;
      runCheck(reason || "unknown");
    }, DECISION_DEBOUNCE_MS);
  }

  async function runCheck(reason) {
    const settings = await fetchSettings();
    if (!settings) return;

    const tiers = normalizeTiers(settings);
    if (!tiers.length) return;

    const cart = await fetchCartFresh();
    const state = computeGiftState(cart, tiers);
    const action = decideAction(state);

    // Make action signature
    const actionSig = [
      action.type,
      fmtTierLabel(action.tierIndex),
      String(state.subtotalPaise),
      String(state.giftCount),
      String(state.currentGiftVariantId || "NONE"),
      String(state.targetGiftVariantId || "NONE")
    ].join("|");

    // If nothing to do => ensure loader off
    if (action.type === "NONE") {
      // if loader was on and state is final, hide
      if (__LOADER_ACTIVE && isFinalState(state)) {
        // avoid hiding on stale cart before mutation completes
        if (__CART_AT > __ACTION_START_CART_AT && (Date.now() - __ACTION_START_AT) > 100) {
          scheduleHide(`Hiding loader for ${fmtTierLabel(state.tierIndex)} | ${action.label}`);
        } else {
          startPollUntilFinal(tiers, `Still waiting | ${fmtTierLabel(state.tierIndex)} | ${action.label}`);
        }
      }
      __LAST_ACTION_SIG = actionSig;
      return;
    }

    // If we already showed loader for same actionSig, don't re-show (but keep polling)
    if (__LAST_ACTION_SIG === actionSig && __LOADER_ACTIVE) {
      startPollUntilFinal(tiers, `Still waiting | ${fmtTierLabel(action.tierIndex)} | ${action.type}`);
      return;
    }
    __LAST_ACTION_SIG = actionSig;

    // Build log text exactly as you want
    const tierText = fmtTierLabel(action.tierIndex);

    if (action.type === "ADD") {
      showNow(`Showing loader for ${tierText} | ADD gift ${action.target} (cart crossed tier)`);
      startPollUntilFinal(tiers, `Hiding loader for ${tierText} | ADD done`);
      return;
    }

    if (action.type === "REMOVE") {
      showNow(`Showing loader for ${tierText} | REMOVE gift(s) (cart dropped below tier / not eligible)`);
      startPollUntilFinal(tiers, `Hiding loader for ${tierText} | REMOVE done`);
      return;
    }

    if (action.type === "SWAP") {
      showNow(`Showing loader for ${tierText} | SWAP gift ${action.from} -> ${action.target} (tier changed)`);
      startPollUntilFinal(tiers, `Hiding loader for ${tierText} | SWAP done`);
      return;
    }

    if (action.type === "CLEANUP") {
      showNow(`Showing loader for ${tierText} | CLEANUP duplicates -> target ${action.target}`);
      startPollUntilFinal(tiers, `Hiding loader for ${tierText} | CLEANUP done`);
      return;
    }
  }

  // -------------------------
  // HOOKS (FAST)
  // -------------------------
  document.addEventListener("DOMContentLoaded", () => {
    queueCheck("init");
    setTimeout(() => queueCheck("init+150"), 150);
  });

  // Manual trigger if needed
  window.runFreeGiftTierLoaderCheck = function (reason) {
    queueCheck(reason || "manual");
  };

  // Patch fetch: when ANY cart op happens, check immediately (fast)
  if (!window.__FG_TIER_LOADER_FETCH_PATCHED) {
    window.__FG_TIER_LOADER_FETCH_PATCHED = true;

    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const input = args[0];
      const url = typeof input === "string" ? input : input?.url;

      const res = await originalFetch.apply(this, args);

      try {
        if (url && (url.includes("/cart/add.js") || url.includes("/cart/change.js") || url.includes("/cart/update.js"))) {
          // Invalidate cache so runCheck sees latest cart
          invalidateCart();
          queueCheck("cartEndpoint");
        }
      } catch (_) {}

      return res;
    };
  }

})();

